import { File } from './../../models/files/files.model';

export class Job {
    id?: string;
    title?: any;
    subtitle?: any;
    location?: any;
    content?: any;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.subtitle = options.subtitle;
        this.location = options.location;
        this.content = options.content;
    }
}
